import { Box, Grid, Stack } from "@mui/material";
import { Custom, Field, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { Preferences } from "assets/data";
import { IPreference } from "interfaces";
import { createStep } from "utils/helpers";
import { forwardRef } from "react";

const StepPreference = forwardRef(() => {
  const { updateData, data } = useWorkflow<Workflow.Utils.OnboardingType>(); // Get updateData from context
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.onboarding.create_profile}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.onboarding_intro}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.onboarding.form_message}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.onboarding.my_interest}
          </Custom.Typography>

          <Box>
            <Grid container spacing={theme.spacing.md}>
              {Preferences.map((item: IPreference) => (
                <Grid key={item._id} item xs={6}>
                  <Field.ImageCheckbox
                    id={item._id}
                    src={item.src}
                    label={item.name}
                    checked={(data.user.preferences as any[]).includes(
                      item._id
                    )}
                    onChange={(id: string, checked: boolean) =>
                      updateData(
                        "user.preferences",
                        checked
                          ? ([...data.user.preferences, id] as any[])
                          : data.user.preferences.filter(
                              (pref: IPreference) => id !== pref._id
                            )
                      )
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Stack>
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.OnboardingType>(StepPreference);
